module.exports = __webpack_public_path__ + "img/life-buoy-01.453e05ab.svg";